/* =========================================================================
   DRIFTCLAD — Shopify theme script
   Cart (AJAX API), predictive search, variant picker, wishlist, her/him,
   rolling banner, lightbox, WhatsApp ordering. No dependencies.
   ========================================================================= */
(function () {
  "use strict";

  const T = window.theme || {};
  const R = T.routes || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const root = (R.root || "/").replace(/\/?$/, "/");

  /* ---------- helpers ---------- */
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage unavailable */ } }
  };

  function formatMoney(cents, format) {
    const fmt = format || T.moneyFormat || "₹{{amount}}";
    const n = (Number(cents) || 0) / 100;
    const group = (num, decimals, thousands, decimal) => {
      const [i, d] = num.toFixed(decimals).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : "");
    };
    const indian = (num) => {
      const [i, d] = num.toFixed(2).split(".");
      const last3 = i.slice(-3), rest = i.slice(0, -3);
      return (rest ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," : "") + last3 + (d === "00" ? "" : "." + d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case "amount": return group(n, 2, ",", ".");
        case "amount_no_decimals": return group(n, 0, ",", ".");
        case "amount_with_comma_separator": return group(n, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return group(n, 0, ".", ",");
        case "amount_with_apostrophe_separator": return group(n, 2, "'", ".");
        case "amount_no_decimals_with_space_separator": return group(n, 0, " ", ".");
        case "amount_with_space_separator": return group(n, 2, " ", ",");
        default: return indian(n);
      }
    });
  }

  const waLink = (text) => `https://wa.me/${T.whatsapp}?text=${encodeURIComponent(text)}`;
  const brand = T.brand || "DRIFTCLAD";

  let toastTimer;
  function toast(msg) {
    const t = $(".toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("on"), 2600);
  }

  /* ---------- drawers / overlays ---------- */
  let lastFocus = null;
  function openPanel(id) {
    closeAll(true);
    const el = document.getElementById(id);
    if (!el) return false;
    lastFocus = document.activeElement;
    el.classList.add("on");
    el.setAttribute("aria-hidden", "false");
    if (id !== "search") $(".scrim") && $(".scrim").classList.add("on");
    document.body.classList.add("lock");
    setTimeout(() => {
      const f = id === "search" ? $("[data-search-input]") : $("button, a, input", el);
      f && f.focus({ preventScroll: true });
    }, 180);
    return true;
  }
  function closeAll(silent) {
    $$(".drawer.on, .search-panel.on, .modal.on").forEach((el) => { el.classList.remove("on"); el.setAttribute("aria-hidden", "true"); });
    $(".scrim") && $(".scrim").classList.remove("on");
    document.body.classList.remove("lock");
    if (!silent && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-open]");
    if (o) {
      if (o.dataset.open === "cart" && T.cartType === "page") return; // follow the link to /cart
      if (openPanel(o.dataset.open)) e.preventDefault();
      return;
    }
    if (e.target.closest("[data-close]") || e.target.classList.contains("modal")) closeAll();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") { closeAll(); lbClose(); } });

  /* ---------- cart (Shopify AJAX API) ---------- */
  function updateCartCount(count) {
    $$('[data-badge="cart"]').forEach((b) => { b.textContent = count; b.classList.toggle("show", count > 0); });
  }
  function renderDrawer(html) {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, "text/html");
    ["[data-cart-body]", "[data-cart-foot]", ".drawer-head h3"].forEach((sel) => {
      const fresh = $(`#cart ${sel}`, doc) || $(sel, doc), cur = $(`#cart ${sel}`);
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    });
  }
  async function refreshCart() {
    const [cart, sec] = await Promise.all([
      fetch(`${R.cart}.js`, { headers: { Accept: "application/json" } }).then((r) => r.json()),
      fetch(`${root}?sections=cart-drawer`).then((r) => r.json()).catch(() => null)
    ]);
    updateCartCount(cart.item_count);
    if (sec) renderDrawer(sec["cart-drawer"]);
    return cart;
  }
  async function addToCart(items, btn) {
    btn && btn.classList.add("loading");
    try {
      const res = await fetch(`${R.cartAdd}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items, sections: "cart-drawer", sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || "Couldn’t add to bag");
      if (T.cartType === "page") { location.href = R.cart; return; }
      if (data.sections) renderDrawer(data.sections["cart-drawer"]);
      const cart = await fetch(`${R.cart}.js`, { headers: { Accept: "application/json" } }).then((r) => r.json());
      updateCartCount(cart.item_count);
      openPanel("cart");
      return true;
    } catch (err) {
      toast(err.message);
      return false;
    } finally {
      btn && btn.classList.remove("loading");
    }
  }
  async function changeLine(line, quantity) {
    const body = $("[data-cart-body]");
    body && body.classList.add("is-loading");
    try {
      const res = await fetch(`${R.cartChange}.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line, quantity, sections: "cart-drawer", sections_url: location.pathname })
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || "Couldn’t update the bag");
      if (data.sections) renderDrawer(data.sections["cart-drawer"]);
      updateCartCount(data.item_count);
      if (document.body.classList.contains("template-cart")) location.reload();
    } catch (err) {
      toast(err.message);
    } finally {
      const b = $("[data-cart-body]");
      b && b.classList.remove("is-loading");
    }
  }
  async function whatsappCart() {
    const cart = await fetch(`${R.cart}.js`, { headers: { Accept: "application/json" } }).then((r) => r.json());
    if (!cart.item_count) return toast("Your bag is empty");
    const lines = cart.items.map((it, i) => `${i + 1}. ${it.product_title}${it.variant_title ? " — " + it.variant_title : ""}\n    Qty: ${it.quantity}  |  ${formatMoney(it.final_line_price)}`);
    const text = `Hi ${brand}! I'd like to order:\n\n${lines.join("\n")}\n\nTotal: ${formatMoney(cart.total_price)}\n${cart.note ? "\nNote: " + cart.note + "\n" : ""}\nPlease share payment & delivery details.`;
    window.open(waLink(text), "_blank", "noopener");
  }

  document.addEventListener("click", (e) => {
    const q = e.target.closest("[data-line-qty]");
    if (q) { e.preventDefault(); changeLine(+q.dataset.lineQty, Math.max(0, +q.dataset.qty)); return; }
    const wc = e.target.closest("[data-wa-cart]");
    if (wc) { e.preventDefault(); whatsappCart(); return; }
    const qa = e.target.closest("[data-quick]");
    if (qa) {
      e.preventDefault();
      e.stopPropagation();
      addToCart([{ id: +qa.dataset.quick, quantity: 1 }], qa).then((ok) => ok && toast(`${qa.dataset.title} added to bag`));
    }
  });

  // cart page: update totals when a quantity changes
  document.addEventListener("change", (e) => {
    if (e.target.matches("[data-cart-page-qty]")) e.target.form.requestSubmit ? e.target.form.requestSubmit($('[name="update"]', e.target.form)) : e.target.form.submit();
  });

  /* ---------- wishlist (stored on this device) ---------- */
  let wish = store.get("dc_wish", []);
  function syncWish() {
    $$("[data-wish]").forEach((b) => {
      const on = wish.includes(b.dataset.wish);
      b.classList.toggle("on", on);
      b.setAttribute("aria-pressed", on);
      const label = $("span", b);
      if (label && b.classList.contains("btn")) label.textContent = on ? "Saved to wishlist" : "Save to wishlist";
    });
    $$('[data-badge="wish"]').forEach((b) => { b.textContent = wish.length; b.classList.toggle("show", wish.length > 0); });
    $$('[data-badge-text="wish"]').forEach((b) => { b.textContent = wish.length ? `${wish.length} saved` : ""; });
  }
  document.addEventListener("click", (e) => {
    const w = e.target.closest("[data-wish]");
    if (!w) return;
    e.preventDefault();
    e.stopPropagation();
    const h = w.dataset.wish, on = wish.includes(h);
    wish = on ? wish.filter((x) => x !== h) : [...wish, h];
    store.set("dc_wish", wish);
    syncWish();
    toast(on ? "Removed from wishlist" : "Saved to wishlist");
    if ($("[data-wishlist-grid]") && on) initWishlistPage();
  });
  async function initWishlistPage() {
    const grid = $("[data-wishlist-grid]"), empty = $("[data-wishlist-empty]");
    if (!grid) return;
    if (!wish.length) { grid.innerHTML = ""; empty.hidden = false; return; }
    empty.hidden = true;
    const cards = await Promise.all(wish.map((h, i) =>
      fetch(`${root}products/${encodeURIComponent(h)}?section_id=card-ajax`).then((r) => (r.ok ? r.text() : "")).then((html) => {
        const card = new DOMParser().parseFromString(html, "text/html").querySelector(".card");
        if (!card) return "";
        if (i % 2) { card.classList.add("him"); }
        return card.outerHTML;
      }).catch(() => "")));
    grid.innerHTML = cards.join("");
    if (!grid.children.length) empty.hidden = false;
    syncWhoButtons(grid);
    syncWish();
    reveal();
  }

  /* ---------- her / him ---------- */
  function syncWhoButtons(scope) {
    $$(".card", scope).forEach((c) => {
      const him = c.classList.contains("him");
      $$("[data-who]", c).forEach((b) => { const on = (b.dataset.who === "him") === him; b.classList.toggle("on", on); b.setAttribute("aria-pressed", on); });
    });
  }
  document.addEventListener("click", (e) => {
    const w = e.target.closest("[data-who]");
    if (!w) return;
    e.preventDefault();
    e.stopPropagation();
    const c = w.closest(".card");
    c.classList.toggle("him", w.dataset.who === "him");
    syncWhoButtons(c.parentElement);
  }, true);

  function initCollection(scope = document) {
    const seg = $("[data-model]", scope), grid = $("[data-collection-grid]", scope);
    if (seg && grid) {
      let model = store.get("dc_model", "mixed");
      const apply = () => {
        $$("[data-m]", seg).forEach((b) => { b.classList.toggle("on", b.dataset.m === model); b.setAttribute("aria-pressed", b.dataset.m === model); });
        $$(".card", grid).forEach((c, i) => {
          const paired = !!$("[data-who]", c);
          c.classList.toggle("him", paired && (model === "him" || (model === "mixed" && i % 2 === 1)));
        });
        syncWhoButtons(grid);
      };
      seg.addEventListener("click", (e) => { const b = e.target.closest("[data-m]"); if (!b) return; model = b.dataset.m; store.set("dc_model", model); apply(); });
      apply();
    }
    const sort = $("[data-sort]", scope);
    if (sort) sort.addEventListener("change", () => {
      const u = new URL(location.href);
      u.searchParams.set("sort_by", sort.value);
      u.searchParams.delete("page");
      location.href = u.toString();
    });
  }

  /* ---------- product page ---------- */
  function initProduct(scope = document) {
    const sec = $("[data-product-section]", scope);
    const jsonEl = $("[data-product-json]", scope);
    if (!sec || !jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = $("[data-product-form]", sec) || $("form[action*='/cart/add']", sec);
    const idInput = $("[data-variant-id]", sec);
    const addBtn = $("[data-add]", sec);
    const err = $(".size-err", sec);
    const groups = $$("[data-option-index]", sec);
    const selected = groups.map((g) => { const on = $("button.on", g); return on ? on.dataset.value : null; });

    const findVariant = () => (selected.every((v) => v !== null) ? product.variants.find((v) => v.options.every((o, i) => o === selected[i])) : null);
    let variant = idInput && idInput.value ? product.variants.find((v) => String(v.id) === idInput.value) : null;
    if (!groups.length) variant = product.variants[0];

    function paintAvailability() {
      groups.forEach((g, gi) => {
        $$("button", g).forEach((b) => {
          // a value is available if some in-stock variant has it and matches the other chosen options
          const possible = product.variants.some((v) => v.available && v.options[gi] === b.dataset.value &&
            v.options.every((o, i) => i === gi || selected[i] === null || o === selected[i]));
          b.classList.toggle("unavailable", !possible);
        });
      });
    }
    function paint() {
      if (idInput) idInput.value = variant ? variant.id : "";
      const priceEl = $("[data-price]", sec);
      if (priceEl && variant) {
        const sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceEl.innerHTML = `<span>${formatMoney(variant.price)}</span>${sale ? `<s>${formatMoney(variant.compare_at_price)}</s><span class="sale-badge">Sale</span>` : ""}`;
      }
      if (addBtn) {
        const avail = variant ? variant.available : product.available;
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? "Add to bag" : "Sold out";
      }
      if (variant && groups.length) {
        const u = new URL(location.href);
        u.searchParams.set("variant", variant.id);
        history.replaceState(null, "", u.toString());
      }
      paintAvailability();
    }
    groups.forEach((g, gi) => g.addEventListener("click", (e) => {
      const b = e.target.closest("button[data-value]");
      if (!b) return;
      selected[gi] = b.dataset.value;
      $$("button", g).forEach((x) => { x.classList.toggle("on", x === b); x.setAttribute("aria-checked", x === b); });
      variant = findVariant();
      if (err) err.textContent = "";
      paint();
    }));
    paintAvailability();

    const need = () => {
      if (variant) return true;
      const g = groups[Math.max(0, selected.indexOf(null))];
      if (err) err.textContent = `Please select a ${g ? g.getAttribute("aria-label").toLowerCase() : "size"}.`;
      if (g) { g.classList.remove("shake"); void g.offsetWidth; g.classList.add("shake"); g.scrollIntoView({ behavior: "smooth", block: "center" }); }
      return false;
    };
    const qtyEl = $("[data-pqty]", sec);
    $$("[data-pq]", sec).forEach((b) => b.addEventListener("click", () => {
      qtyEl.value = Math.max(1, Math.min(10, (+qtyEl.value || 1) + +b.dataset.pq));
    }));
    const add = () => { if (need()) addToCart([{ id: variant.id, quantity: Math.max(1, +(qtyEl && qtyEl.value) || 1) }], addBtn); };
    if (form) form.addEventListener("submit", (e) => { e.preventDefault(); add(); });

    const waNow = () => {
      if (!need()) return;
      const qty = Math.max(1, +(qtyEl && qtyEl.value) || 1);
      const colour = sec.dataset.colourway ? ` — ${sec.dataset.colourway}` : "";
      const text = `Hi ${brand}! I'd like to order:\n\n${product.title}${colour}\n${variant.title !== "Default Title" ? "Size: " + variant.title + "\n" : ""}Qty: ${qty}\nPrice: ${formatMoney(variant.price * qty)}\n\n${location.origin}${product.url || location.pathname}\n\nPlease share payment & delivery details.`;
      window.open(waLink(text), "_blank", "noopener");
    };
    $$("[data-wa-now]", sec).forEach((b) => b.addEventListener("click", waNow));

    const sb = $("[data-sticky-buy]", scope);
    if (sb && addBtn) {
      document.body.classList.add("has-sticky");
      $("[data-sb-add]", sb).addEventListener("click", add);
      const sbwa = $("[data-sb-wa]", sb);
      sbwa && sbwa.addEventListener("click", waNow);
      new IntersectionObserver(([en]) => sb.classList.toggle("on", !en.isIntersecting && en.boundingClientRect.top < 0)).observe(addBtn);
    }

    // gallery: her / him filter, dots, lightbox
    const gal = $("[data-gallery]", sec), dots = $("[data-gal-dots]", scope);
    const visible = () => $$("[data-zoom]", gal).filter((b) => !b.hidden);
    const paintDots = () => { if (dots) dots.innerHTML = visible().map((_, k) => `<i class="${k ? "" : "on"}"></i>`).join(""); };
    const gf = $("[data-gal-filter]", sec);
    if (gf) gf.addEventListener("click", (e) => {
      const b = e.target.closest("[data-g]");
      if (!b) return;
      $$("[data-g]", gf).forEach((x) => { x.classList.toggle("on", x === b); x.setAttribute("aria-pressed", x === b); });
      $$("[data-zoom]", gal).forEach((im) => { im.hidden = b.dataset.g !== "all" && im.dataset.whoImg !== b.dataset.g; });
      gal.scrollLeft = 0;
      paintDots();
    });
    paintDots();
    gal && gal.addEventListener("scroll", () => {
      const first = visible()[0];
      if (!first) return;
      const i = Math.round(gal.scrollLeft / (first.offsetWidth + 4));
      $$("i", dots).forEach((d, k) => d.classList.toggle("on", k === i));
    }, { passive: true });
    gal && gal.addEventListener("click", (e) => {
      const b = e.target.closest("[data-zoom]");
      if (!b || !b.dataset.src) return;
      const items = visible().map((x) => ({ src: x.dataset.src, cap: product.title + (x.dataset.whoImg ? ` · worn by ${x.dataset.whoImg}` : "") }));
      openLightbox(items, visible().indexOf(b));
    });
  }

  /* ---------- recommendations ---------- */
  function initRecommendations(scope = document) {
    $$("[data-recommendations]", scope).forEach(async (el) => {
      if (el.dataset.loaded) return;
      el.dataset.loaded = "1";
      try {
        const html = await fetch(el.dataset.url).then((r) => r.text());
        const fresh = new DOMParser().parseFromString(html, "text/html").querySelector("[data-recommendations]");
        if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; syncWish(); syncWhoButtons(el); reveal(); }
      } catch (e) { /* recommendations are optional */ }
    });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    const input = $("[data-search-input]"), out = $("[data-search-results]");
    if (!input || !out) return;
    let timer, ctrl;
    input.addEventListener("input", () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { out.innerHTML = ""; return; }
      timer = setTimeout(async () => {
        ctrl && ctrl.abort();
        ctrl = new AbortController();
        try {
          const url = `${R.predictiveSearch}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&section_id=predictive-search`;
          const html = await fetch(url, { signal: ctrl.signal }).then((r) => r.text());
          const doc = new DOMParser().parseFromString(html, "text/html");
          const sec = doc.querySelector(".shopify-section") || doc.body;
          out.innerHTML = sec.innerHTML;
        } catch (e) { /* aborted */ }
      }, 220);
    });
  }

  /* ---------- lightbox ---------- */
  let lbEl = null, lbItems = [], lbI = 0;
  function openLightbox(items, k) {
    if (!items.length) return;
    if (!lbEl) {
      lbEl = document.createElement("div");
      lbEl.className = "lightbox";
      lbEl.setAttribute("role", "dialog");
      lbEl.setAttribute("aria-hidden", "true");
      lbEl.innerHTML = `<div class="lb-top"><span class="eyebrow" data-lb-count></span><button type="button" class="icon-btn" data-lb-close aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>
        <div class="lb-stage"><button type="button" class="lb-nav lb-prev" data-lb="-1" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M15 5l-7 7 7 7"/></svg></button><img alt=""><button type="button" class="lb-nav lb-next" data-lb="1" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M9 5l7 7-7 7"/></svg></button></div>
        <div class="lb-bottom"><span class="s" style="font-size:20px" data-lb-cap></span><a class="btn btn-light" style="height:44px" data-lb-shop>Shop this look</a></div>`;
      document.body.append(lbEl);
      lbEl.addEventListener("click", (e) => {
        const n = e.target.closest("[data-lb]");
        if (n) lbStep(+n.dataset.lb);
        else if (e.target.closest("[data-lb-close]") || e.target.classList.contains("lb-stage")) lbClose();
      });
      document.addEventListener("keydown", (e) => {
        if (!lbEl.classList.contains("on")) return;
        if (e.key === "ArrowRight") lbStep(1);
        if (e.key === "ArrowLeft") lbStep(-1);
      });
      let sx = 0;
      lbEl.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; }, { passive: true });
      lbEl.addEventListener("touchend", (e) => { const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) lbStep(dx < 0 ? 1 : -1); });
    }
    lbItems = items; lbI = Math.max(0, k);
    lbShow();
    lbEl.classList.add("on");
    lbEl.setAttribute("aria-hidden", "false");
    document.body.classList.add("lock");
  }
  function lbShow() {
    const it = lbItems[lbI];
    $("img", lbEl).src = it.src;
    $("img", lbEl).alt = it.cap || "";
    $("[data-lb-count]", lbEl).textContent = `${lbI + 1} / ${lbItems.length}`;
    $("[data-lb-cap]", lbEl).textContent = it.cap || "";
    const shop = $("[data-lb-shop]", lbEl);
    shop.style.display = it.href ? "" : "none";
    if (it.href) shop.href = it.href;
  }
  function lbStep(d) { lbI = (lbI + d + lbItems.length) % lbItems.length; lbShow(); }
  function lbClose() { if (!lbEl || !lbEl.classList.contains("on")) return; lbEl.classList.remove("on"); lbEl.setAttribute("aria-hidden", "true"); document.body.classList.remove("lock"); }

  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-jz]");
    if (!b) return;
    const group = $$("[data-jz]", b.parentElement);
    openLightbox(group.map((x) => ({ src: x.dataset.src, cap: x.dataset.cap, href: x.dataset.href })), group.indexOf(b));
  });

  /* ---------- poster carousel arrows ---------- */
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-scroll]");
    if (!b) return;
    const sc = $("[data-scroller]", b.closest(".shopify-section") || document);
    sc && sc.scrollBy({ left: +b.dataset.scroll * sc.clientWidth * 0.8, behavior: "smooth" });
  });

  /* ---------- announcement bar ---------- */
  function initAnnounce(scope = document) {
    $$("[data-announce]", scope).forEach((bar) => {
      const lis = $$("li", bar);
      clearInterval(bar._t);
      if (lis.length < 2) return;
      let a = 0;
      bar._t = setInterval(() => { lis[a].classList.remove("on"); a = (a + 1) % lis.length; lis[a].classList.add("on"); }, +bar.dataset.speed || 4000);
    });
  }

  /* ---------- header over the home banner ---------- */
  let headerScroll;
  function initHeader() {
    // the sticky header creates its own stacking layer; lift the phone menu + search panel to <body> so they sit above everything
    ["menu", "search"].forEach((id) => {
      const els = $$(`#${id}`);
      const fresh = els.find((el) => el.parentElement !== document.body) || null;
      if (fresh) { els.filter((el) => el !== fresh).forEach((el) => el.remove()); document.body.append(fresh); }
    });
    const header = $("[data-header]");
    if (!header) return;
    const first = $("main > .shopify-section:first-child [data-hero]");
    const over = first && first.dataset.transparentHeader === "true";
    if (headerScroll) removeEventListener("scroll", headerScroll);
    header.classList.toggle("over", !!over);
    if (!over) { header.classList.remove("ink"); return; }
    headerScroll = () => header.classList.toggle("over", window.scrollY < first.offsetHeight - 120);
    addEventListener("scroll", headerScroll, { passive: true });
    headerScroll();
  }

  /* ---------- rolling banner ---------- */
  function initHero(scope = document) {
    $$("[data-hero]", scope).forEach((el) => {
      const slides = $$(".hs-slide", el), bars = $$("[data-hs-go]", el), header = $("[data-header]");
      if (!slides.length) return;
      const small = matchMedia("(max-width: 760px)");
      let cur = Math.max(0, slides.findIndex((s) => s.classList.contains("on")));
      const go = (n) => {
        slides[cur].classList.remove("on");
        slides[cur].setAttribute("aria-hidden", "true");
        cur = (n + slides.length) % slides.length;
        slides[cur].classList.add("on");
        slides[cur].removeAttribute("aria-hidden");
        $$("img[loading=lazy]", slides[cur]).forEach((im) => im.removeAttribute("loading"));
        $$("img[loading=lazy]", slides[(cur + 1) % slides.length]).forEach((im) => im.removeAttribute("loading"));
        bars.forEach((b, k) => { b.classList.toggle("on", k === cur); b.classList.toggle("past", k < cur); });
        const n2 = $("[data-hs-n]", el);
        if (n2) n2.textContent = String(cur + 1).padStart(2, "0");
        const light = slides[cur].classList.contains("light") && !small.matches;
        el.classList.toggle("light", light);
        header && header.classList.toggle("ink", light && header.classList.contains("over"));
      };
      el._go = go;
      if (el._wired) { go(cur); return; }
      el._wired = true;
      bars.forEach((b) => $("i", b).addEventListener("animationend", () => { if (!document.documentElement.classList.contains("shopify-design-mode") || !el.classList.contains("hold")) go(cur + 1); }));
      el.addEventListener("click", (e) => {
        const g = e.target.closest("[data-hs-go]"), st = e.target.closest("[data-hs-step]");
        if (g) go(+g.dataset.hsGo);
        if (st) go(cur + +st.dataset.hsStep);
      });
      const pause = (on) => el.classList.toggle("paused", on);
      el.addEventListener("mouseenter", () => matchMedia("(hover: hover)").matches && pause(true));
      el.addEventListener("mouseleave", () => pause(false));
      document.addEventListener("visibilitychange", () => pause(document.hidden));
      el.addEventListener("keydown", (e) => { if (e.key === "ArrowRight") go(cur + 1); if (e.key === "ArrowLeft") go(cur - 1); });
      let sx = 0, sy = 0;
      el.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      el.addEventListener("touchend", (e) => {
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(cur + (dx < 0 ? 1 : -1));
      });
      small.addEventListener("change", () => go(cur));
      go(cur);
    });
  }

  /* ---------- misc forms ---------- */
  function initForms(scope = document) {
    const f = $("[data-track]", scope);
    if (f && !f._wired) {
      f._wired = true;
      const fieldErr = (name, msg) => { const fl = f.elements[name].closest(".field"); fl.classList.toggle("err", !!msg); $(".msg", fl).textContent = msg || ""; return !msg; };
      f.addEventListener("submit", (e) => {
        e.preventDefault();
        const id = f.elements.order.value.trim(), ph = f.elements.phone.value.replace(/[\s-]/g, "");
        const ok = [fieldErr("order", /^#?\w{3,}/.test(id) ? "" : "Enter your order number (e.g. #1001)."),
          fieldErr("phone", /^(\+?91)?[6-9]\d{9}$/.test(ph) ? "" : "Enter a valid 10-digit mobile number.")].every(Boolean);
        if (!ok) return;
        window.open(waLink(`Hi ${brand}! Please share the status of my order.\n\nOrder: ${id.startsWith("#") ? id : "#" + id}\nMobile: ${ph}`), "_blank", "noopener");
      });
    }
    $$("[data-toggle-recover]", scope).forEach((a) => a.addEventListener("click", (e) => {
      e.preventDefault();
      $("[data-login-panel]").hidden = !$("[data-login-panel]").hidden;
      $("[data-recover-panel]").hidden = !$("[data-recover-panel]").hidden;
    }));
    if (location.hash === "#recover" && $("[data-recover-panel]")) { $("[data-login-panel]").hidden = true; $("[data-recover-panel]").hidden = false; }
    $$("select[data-default]", scope).forEach((s) => { if (s.dataset.default) s.value = s.dataset.default; });
  }

  /* ---------- reveal on scroll ---------- */
  let io;
  function reveal() {
    if (!("IntersectionObserver" in window) || document.documentElement.classList.contains("shopify-design-mode")) { $$(".reveal").forEach((el) => el.classList.add("in")); return; }
    io = io || new IntersectionObserver((ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } }), { rootMargin: "0px 0px -8% 0px" });
    $$(".reveal:not(.in)").forEach((el) => io.observe(el));
  }

  /* ---------- image protection (deterrent) ---------- */
  if (T.protectImages) {
    document.addEventListener("contextmenu", (e) => { if (e.target.tagName === "IMG") e.preventDefault(); });
    document.addEventListener("dragstart", (e) => { if (e.target.tagName === "IMG") e.preventDefault(); });
  }

  /* ---------- boot ---------- */
  function initAll(scope = document) {
    initAnnounce(scope);
    initHero(scope);
    initCollection(scope);
    initProduct(scope);
    initRecommendations(scope);
    initForms(scope);
    syncWhoButtons(scope);
    syncWish();
    reveal();
  }
  initAll();
  initHeader();
  initSearch();
  initWishlistPage();
  addEventListener("load", () => document.body.classList.add("loaded"));
  setTimeout(() => document.body.classList.add("loaded"), 600);

  /* ---------- theme editor ---------- */
  if (window.Shopify && Shopify.designMode) {
    document.documentElement.classList.add("shopify-design-mode");
    document.addEventListener("shopify:section:load", (e) => { initAll(e.target); initHeader(); });
    document.addEventListener("shopify:section:unload", () => setTimeout(initHeader, 0));
    document.addEventListener("shopify:block:select", (e) => {
      const hero = e.target.closest("[data-hero]");
      if (hero && hero._go) { hero.classList.add("paused", "hold"); hero._go($$(".hs-slide", hero).indexOf(e.target)); }
    });
    document.addEventListener("shopify:block:deselect", (e) => {
      const hero = e.target.closest("[data-hero]");
      if (hero) hero.classList.remove("paused", "hold");
    });
  }

  window.DriftcladTheme = { addToCart, refreshCart, formatMoney, openPanel };
})();
